import Axios from 'axios';

const examGuide = {
  axios() {
    let AxiosInstance = Axios;
    AxiosInstance.defaults.baseURL = process.env.EXAM_GUIDE_URL;
    return AxiosInstance;
  },
  examSearch(searchText) {
    return this.axios().get('exams', {
      params: {
        searchText,
      },
    });
  },
  mostSearched() {
    return this.axios().get('mostSearched');
  },
  examDetails(id) {
    return this.axios().get('exams/details/' + id);
  },
  examSearchAll(page) {
    return this.axios().get('exams/all', {
      params: {
        page,
      },
    });
  },
  getExamDetailsByMnemonic(mnemonic) {
    return this.axios().get('exams/details/mnemonic/' + mnemonic);
  },
  getIntegrationParams(mnemonic) {
    return this.axios().get('exams/integration/parameter/mnemonic/' + mnemonic);
  },
  getRestrictedExamDetailsByMnemonic(mnemonic) {
    return this.axios().get('exams/details/restricted/mnemonic/' + mnemonic);
  },
  getExamReferenceValues(id) {
    return this.axios().get('exams/reference-value/mnemonic/' + id);
  },
};

export default examGuide;
